export const capitalizeFirstLetter = (string = '') => {
  return string?.charAt(0)?.toUpperCase() + string?.slice(1) || ''
}

export function capitalizeWords(str) {
  return str.replace(/\b\w/g, char => char.toUpperCase())
}
